export default __webpack_public_path__ + "static/spesifisitet-a86cfb5d9ae2d7b121d30802b1305354.png";